import { createRouter, createWebHistory } from 'vue-router'
import AuthorizationService from '@/services/AuthorizationService'

const LoginPage = () => import('@/pages/LoginPage.vue')
const LandingPage = () => import('@/pages/LandingPage.vue')
const DashboardCallers = () => import('@/pages/Dashboard/DashboardCallers.vue')
const AdminDashboard = () => import('@/pages/Dashboard/AdminDashboard.vue')
const UserDashboard = () => import('@/pages/Dashboard/UserDashboard.vue')
const AccessDeniedPage = () => import('@/pages/AccessDeniedPage.vue')
const MaintenanceModeEnabledPage = () => import('@/pages/MaintenanceModeEnabledPage.vue')
const NotFoundPage = () => import('@/pages/NotFoundPage.vue')
const DashboardAccountsCustomer = () => import('@/pages/Dashboard/DashboardAccountsCustomer.vue')
const InventoryLedger = () => import('@/pages/Reports/InventoryLedger.vue')
const Locations = () => import('@/pages/Locations/LocationsPage.vue')
const AuthorizedLocations = () => import('@/pages/Locations/AuthorizedLocationsPage.vue')
const LocationCreate = () => import('@/pages/Locations/LocationCreate.vue')
const Accounts = () => import('@/pages/Accounts/AccountsPage.vue')
const AccountCreate = () => import('@/pages/Accounts/AccountCreate.vue')
const AccountDashboard = () => import('@/pages/AccountDetails/AccountDashboard/AccountDashboard.vue')
const AccountDetailsContainer = () => import('@/pages/AccountDetails/AccountDetailsContainer.vue')
const AccountInventoryLocationSummary = () => import('@/pages/AccountDetails/AccountInventoryLocationSummary.vue')
const AccountProgramDashboard = () => import('@/pages/AccountDetails/AccountProgramDashboard.vue')
const AccountInventoryByStage = () => import('@/pages/AccountDetails/AccountInventoryByStage.vue')
const AccountInventoryByStatus = () => import('@/pages/AccountDetails/AccountInventoryByStatus.vue')
const AccountInventoryByNode = () => import('@/pages/AccountDetails/AccountInventoryByNode.vue')
const AccountDetailsWriteOff = () => import('@/pages/AccountDetails/AccountDetailsWriteOff.vue')
const AccountDetailsCapex = () => import('@/pages/AccountDetails/AccountDetailsCapex.vue')
const AccountDetailsDetails = () => import('@/pages/AccountDetails/AccountDetailsDetails.vue')
const AccountDetailsEdit = () => import('@/pages/AccountDetails/AccountDetailsEdit.vue')
const LocationDetailsContainer = () => import('@/pages/LocationDetails/LocationDetailsContainer.vue')
const LocationDetailsInventory = () => import('@/pages/LocationDetails/LocationDetailsInventory.vue')
const LocationInventoryInOut = () => import('@/pages/LocationDetails/LocationInventoryInOut.vue')
const LocationDetailsAdjustment = () => import('@/pages/LocationDetails/LocationDetailsAdjustment.vue')
const LocationDetailsCycleCount = () => import('@/pages/LocationDetails/LocationDetailsCycleCount.vue')
const LocationDetailsProcessingMovement = () => import('@/pages/LocationDetails/LocationDetailsProcessingMovement.vue')
const LocationDetailsCapex = () => import('@/pages/LocationDetails/LocationDetailsCapex.vue')
const LocationDetailsUpdateAssets = () => import('@/pages/LocationDetails/LocationDetailsUpdateAssets.vue')
const LocationDetailsCallLogs = () => import('@/pages/LocationDetails/LocationDetailsCallLogs.vue')
const LocationDetailsUpdateConfirmedAvailable = () => import('@/pages/LocationDetails/UpdateConfirmedAvailable.vue')
const LocationDetailsCreateRecoveryOrders = () => import('@/pages/LocationDetails/CreateRecoveryOrders.vue')
const LocationDetailsDetails = () => import('@/pages/LocationDetails/LocationDetailsDetails.vue')
const LocationDashboardOrders = () => import('@/pages/LocationDetails/LocationDashboardOrders.vue')
const LocationDashboardOrderDetails = () => import('@/pages/LocationDetails/LocationDashboardOrderDetails.vue')
const LocationDashboardNotifications = () => import('@/pages/LocationDetails/LocationDashboardNotifications.vue')
const LocationDetailsEdit = () => import('@/pages/LocationDetails/LocationDetailsEdit.vue')
const LocationDetailsMap = () => import('@/pages/LocationDetails/LocationDetailsMap.vue')
const ManagedLocationDetailsContainer = () => import('@/pages/ManagedLocationDetails/ManagedLocationDetailsContainer.vue')
const ManagedLocationConfirmedAvailable = () => import('@/pages/ManagedLocationDetails/ProviderConfirmedAvailable.vue')
const AccountOverview1 = () => import('@/pages/AccountDetails/AccountOverview1.vue')
const AccountOverview2 = () => import('@/pages/AccountDetails/AccountOverview2.vue')
const Orders = () => import('@/pages/Orders/OrdersPage.vue')
const OrderCreate = () => import('@/pages/Orders/OrderCreate.vue')
const OrderDetail = () => import('@/pages/Orders/OrderDetail.vue')
const BolReceive = () => import('@/pages/BillsOfLading/BolReceive.vue')
const QuoteCreateFromLadingBill = () => import('@/pages/Quote/QuoteCreateFromLadingBill.vue')
const QuoteDetails = () => import('@/pages/Quote/QuoteDetails.vue')
const FilesPage = () => import('@/pages/Files/FilesPage.vue')
const MapsLinks = () => import('@/pages/Maps/MapsLinks.vue')
const LimitedSetMap = () => import('@/pages/Maps/LimitedSetMap.vue')
const LimitedSetWithRouteMap = () => import('@/pages/Maps/LimitedSetWithRouteMap.vue')
const InventoryMap = () => import('@/pages/Maps/InventoryMap.vue')
const LockedMap = () => import('@/pages/Maps/LockedMap.vue')
const ZoneMap = () => import('@/pages/Maps/ZoneMap.vue')
const PlansPage = () => import('@/pages/Plans/PlansPage')
const PlanCreate = () => import('@/pages/Plans/PlanCreate')
const PlanDetail = () => import('@/pages/Plans/PlanDetail')
const ProgramsPage = () => import('@/pages/Programs/ProgramsPage')
const ProgramCreate = () => import('@/pages/Programs/ProgramCreate')
const ProgramDetailsContainer = () => import('@/pages/Programs/Details/ProgramDetailsContainer')
const ProgramDashboard = () => import('@/pages/Programs/Details/ProgramDashboard')
const ProgramEdit = () => import('@/pages/Programs/Details/ProgramEdit')
const ProgramLocations = () => import('@/pages/Programs/Details/ProgramLocations')
const ProgramPlans = () => import('@/pages/Programs/Details/ProgramPlans')
const ProgramSkus = () => import('@/pages/Programs/Details/ProgramSkus')
const InventoryByStage = () => import('@/pages/Reports/InventoryByStage') // formerly InventoryByComponent
const HistoricalInventoryByLocation = () => import('@/pages/Reports/HistoricalInventoryByLocation')
const CurrentInventoryByLocation = () => import('@/pages/Reports/CurrentInventoryByLocation')
const InventoryMovements = () => import('@/pages/Reports/InventoryMovements')
const InventoryLedger99Page = () => import('@/pages/Reports/InventoryLedger99Page')
const InvoicingReportPage = () => import('@/pages/Reports/InvoicingReportPage.vue')
const OrderItemsReportPage = () => import('@/pages/Reports/OrderItemsReportPage.vue')
const LateNotificationsReportPage = () => import('@/pages/Reports/LateNotificationsReportPage.vue')
const PreBillingReportPage = () => import('@/pages/Reports/PreBillingReportPage.vue')
const CycleCountReportPage = () => import('@/pages/Reports/CycleCountReportPage.vue')
const CompletedOrdersReportPage = () => import('@/pages/Reports/CompletedOrdersReportPage.vue')
const ReportsPage = () => import('@/pages/Reports/ReportsList.vue')
const ReportDetail = () => import('@/pages/Reports/ReportDetail.vue')
const ReportJobDetailList = () => import('@/pages/Reports/ReportJobDetailList.vue')
const SkusPage = () => import('@/pages/Skus/SkusPage')
const SkuCreate = () => import('@/pages/Skus/SkuCreate')
const SkuDetailsContainer = () => import('@/pages/Skus/Details/SkuDetailsContainer')
const SkuEdit = () => import('@/pages/Skus/Details/SkuEdit')
const SkuPrograms = () => import('@/pages/Skus/Details/SkuPrograms')
const SkuFreightPackages = () => import('@/pages/Skus/Details/SkuFreightPackages')
const SkuComponents = () => import('@/pages/Skus/Details/SkuComponents')
const SkuParents = () => import('@/pages/Skus/Details/SkuParents')
const SkuEstimators = () => import('@/pages/Skus/Details/SkuEstimators')
const SkuEquivalentDetail = () => import('@/pages/Skus/SkuEquivalentDetail')
const RecoveriesByZone = () => import('@/pages/Recoveries/RecoveriesByZone')
const RecoveriesByLocation = () => import('@/pages/Recoveries/RecoveriesByLocation')
const RecoveriesByLocationByProgram = () => import('@/pages/Recoveries/RecoveriesByLocationByProgram')
const RecoveriesByComponent = () => import('@/pages/Recoveries/RecoveriesByComponent')
const ReplenishmentsByComponent = () => import('@/pages/Replenishments/ReplenishmentsByComponent')
const BolCreate = () => import('@/pages/BillsOfLading/BolCreate')
const BolDetail = () => import('@/pages/BillsOfLading/BolDetail')
const BolPrintable = () => import('@/pages/BillsOfLading/printable/BolPrintable')
const LadingBills = () => import('@/pages/BillsOfLading/LadingBills')
const BatchFileUpload = () => import('@/pages/batch/BatchFileUpload')
const BatchActionLedger = () => import('@/pages/batch/BatchActionLedger')
const BatchFilesList = () => import('@/pages/batch/BatchFilesList')
// const BatchActionDetails = () => import('@/pages/batch/BatchActionDetails')
const BatchActions = () => import('@/pages/batch/BatchActions')
const BatchCreate = () => import('@/pages/batch/BatchCreate')
const WeekNumberConfigList = () => import('@/pages/Admin/WeekNumberConfigList')
const CallPriorityTypeList = () => import('@/pages/Admin/CallPriorityTypeList')
const UsersList = () => import('@/pages/Users/UsersList')
const UserCreate = () => import('@/pages/Users/UserCreate')
const UserDetail = () => import('@/pages/Users/UserDetail')
const MasterAdjustment = () => import('@/pages/Admin/MasterAdjustment')
const ZonesList = () => import('@/pages/Zones/ZonesList.vue')
const ZonesCreate = () => import('@/pages/Zones/ZonesCreate.vue')
const ZonesEdit = () => import('@/pages/Zones/ZonesEdit.vue')
const HelpFiles = () => import('@/pages/Help/HelpFiles')
const ImportUploads = () => import('@/pages/Admin/ImportUploads')
const ImportFilesList = () => import('@/pages/Admin/ImportFilesList')
const ImportFileErrors = () => import('@/pages/Admin/ImportFileErrors')
const DeveloperTools = () => import('@/pages/Admin/DeveloperTools')

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFoundPage',
    component: NotFoundPage,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'AccessDeniedPage',
    component: AccessDeniedPage,
  },
  {
    path: '/maintenance-mode-enabled',
    name: 'MaintenanceModeEnabledPage',
    component: MaintenanceModeEnabledPage,
  },
  {
    path: '/',
    name: 'LandingPage',
    component: LandingPage,
  },
  {
    path: '/dashboard-callers',
    name: 'DashboardCallers',
    component: DashboardCallers,
  },
  {
    path: '/dashboard-callers-coming-soon',
    name: 'AdminDashboard',
    component: AdminDashboard,
  },
  {
    path: '/coming-soon',
    name: 'UserDashboard',
    component: UserDashboard,
  },
  {
    path: '/dashboard-accounts-customer',
    name: 'DashboardAccountsCustomer',
    component: DashboardAccountsCustomer,
  },
  {
    path: '/account-overview-1',
    name: 'AccountOverview1',
    component: AccountOverview1, // TODO: placeholders for Jim's meeting - these will be refactored into actual views
  },
  {
    path: '/account-overview-2',
    name: 'AccountOverview2',
    component: AccountOverview2, // TODO: placeholders for Jim's meeting - these will be refactored into actual views
  },
  {
    path: '/inventory-ledger',
    name: 'InventoryLedger',
    component: InventoryLedger,
  },
  {
    path: '/batch-file-upload',
    name: 'BatchFileUpload',
    component: BatchFileUpload,
  },
  {
    path: '/batch-ledger/:fileId/:lineId?',
    name: 'BatchActionLedger',
    component: BatchActionLedger,
    props: true,
  },
  // {
  //   path: '/batch-action-details/:fileId',
  //   name: 'BatchActionDetails',
  //   component: BatchActionDetails,
  //   props: true,
  // },
  {
    path: '/batch-files',
    name: 'BatchFilesList',
    component: BatchFilesList,
    props: true,
  },
  {
    path: '/batch-actions',
    name: 'BatchActions',
    component: BatchActions,
    props: true,
  },
  {
    path: '/batch-create',
    name: 'BatchCreate',
    component: BatchCreate,
  },
  {
    path: '/locations',
    name: 'Locations',
    component: Locations,
  },
  {
    path: '/authorized-locations',
    name: 'AuthorizedLocations',
    component: AuthorizedLocations,
  },
  {
    path: '/locations/new',
    name: 'LocationCreate',
    component: LocationCreate,
  },
  {
    path: '/location-details/:code',
    name: 'LocationDetail',
    component: LocationDetailsContainer,
    props: true,
    children: [
      {
        path: 'dashboard-orders',
        name: 'LocationDashboardOrders',
        component: LocationDashboardOrders,
      },
      {
        path: 'dashboard-notifications',
        name: 'LocationDashboardNotifications',
        component: LocationDashboardNotifications,
      },
      {
        path: 'dashboard-order-details',
        name: 'LocationDashboardOrderDetails',
        component: LocationDashboardOrderDetails,
      },
      // {
      //   path: 'provider-dashboard',
      //   name: 'LocationDetailsProviderDashboard',
      //   component: LocationDetailsProviderDashboard,
      // },
      {
        path: 'inventory',
        name: 'LocationDetailsInventory',
        component: LocationDetailsInventory,
        props: true,
      },
      {
        path: 'inventory-in-out',
        name: 'LocationInventoryInOut',
        component: LocationInventoryInOut,
        props: true,
      },
      {
        path: 'processing',
        name: 'LocationDetailsProcessingMovement',
        component: LocationDetailsProcessingMovement,
        props: true,
      },
      {
        path: 'adjustment',
        name: 'LocationDetailsAdjustment',
        component: LocationDetailsAdjustment,
        props: true,
      },
      {
        path: 'cycle-count',
        name: 'LocationDetailsCycleCount',
        component: LocationDetailsCycleCount,
        props: true,
      },
      {
        path: 'capex',
        name: 'LocationDetailsCapex',
        component: LocationDetailsCapex,
        props: true,
      },
      {
        path: 'update-assets',
        name: 'LocationDetailsUpdateAssets',
        component: LocationDetailsUpdateAssets,
        props: true,
      },
      {
        path: 'call-logs',
        name: 'LocationDetailsCallLogs',
        component: LocationDetailsCallLogs,
        props: true,
      },
      {
        path: 'map',
        name: 'LocationDetailsMap',
        component: LocationDetailsMap,
      },
      {
        path: 'details',
        name: 'LocationDetailsDetails',
        component: LocationDetailsDetails,
      },
      {
        path: 'edit',
        name: 'LocationDetailsEdit',
        component: LocationDetailsEdit,
      },
      {
        path: 'update-confirmed-available',
        name: 'UpdateConfirmedAvailable',
        component: LocationDetailsUpdateConfirmedAvailable,
        props: true,
      },
      {
        path: 'create-recovery-orders',
        name: 'CreateRecoveryOrders',
        component: LocationDetailsCreateRecoveryOrders,
        props: true,
      },
    ],
  },
  {
    path: '/managed-location-details/:code',
    name: 'ManagedLocationDetail',
    component: ManagedLocationDetailsContainer,
    props: true,
    children: [
      {
        path: 'confirmed-available',
        name: 'ManagedLocationConfirmedAvailable',
        component: ManagedLocationConfirmedAvailable,
        props: true,
      },
    ],
  },
  {
    path: '/replenishments-by-component',
    name: 'ReplenishmentsByComponent',
    component: ReplenishmentsByComponent,
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: Accounts,
  },
  {
    path: '/accounts/new',
    name: 'AccountCreate',
    component: AccountCreate,
  },
  {
    path: '/accounts/:code',
    name: 'AccountDetail',
    component: AccountDetailsContainer,
    children: [
      {
        path: 'inventory-location-summary',
        name: 'AccountInventoryLocationSummary',
        component: AccountInventoryLocationSummary,
        props: true,
      },
      {
        path: 'dashboard',
        name: 'AccountDashboard',
        component: AccountDashboard,
        props: true,
      },
      {
        path: 'program-dashboard',
        name: 'AccountProgramDashboard',
        component: AccountProgramDashboard,
        props: true,
      },
      {
        path: 'inventory-by-stage',
        name: 'AccountInventoryByStage',
        component: AccountInventoryByStage,
        props: true,
      },
      {
        path: 'inventory-by-status',
        name: 'AccountInventoryByStatus',
        component: AccountInventoryByStatus,
        props: true,
      },
      {
        path: 'inventory-by-node',
        name: 'AccountInventoryByNode',
        component: AccountInventoryByNode,
        props: true,
      },
      {
        path: 'processingMovement',
        name: 'AccountOverview1',
        component: AccountOverview1,
        props: true,
      },
      {
        path: 'adjustment',
        name: 'AccountOverview2',
        component: AccountOverview2,
        props: true,
      },
      {
        path: 'write-off',
        name: 'AccountDetailsWriteOff',
        component: AccountDetailsWriteOff,
        props: true,
      },
      {
        path: 'capex',
        name: 'AccountDetailsCapex',
        component: AccountDetailsCapex,
        props: true,
      },
      {
        path: 'details',
        name: 'AccountDetailsDetails',
        component: AccountDetailsDetails,
      },
      {
        path: 'edit',
        name: 'AccountDetailsEdit',
        component: AccountDetailsEdit,
      },
    ],
  },
  {
    path: '/account/:id',
    name: 'AccountDetailsDetailsById',
    component: AccountDetailsDetails,
  },
  {
    path: '/create-order',
    name: 'OrderForms',
    component: OrderCreate,
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
  },
  {
    path: '/orders/:orderId',
    name: 'OrderDetails',
    component: OrderDetail,
    props: true,
  },
  {
    path: '/create-bill-of-lading',
    name: 'LadingBillCreate',
    component: BolCreate,
  },
  {
    path: '/bills-of-lading',
    name: 'LadingBills',
    component: LadingBills,
    props: true,
  },
  {
    path: '/bills-of-lading/:bolId',
    name: 'LadingBillDetail',
    component: BolDetail,
    props: true,
  },
  {
    path: '/bills-of-lading/:bolId/print',
    name: 'LadingBillPrintable',
    component: BolPrintable,
    props: true,
  },
  {
    path: '/bills-of-lading/receive/:bolId',
    name: 'ReceiveLadingBill',
    component: BolReceive,
    props: true,
  },
  {
    path: '/create-quote-from-bill-of-lading/:bolId',
    name: 'QuoteCreateFromLadingBill',
    component: QuoteCreateFromLadingBill,
    props: true,
  },
  {
    path: '/quote-details/:quoteId',
    name: 'QuoteDetails',
    component: QuoteDetails,
    props: true,
  },
  {
    path: '/files',
    name: 'Files',
    component: FilesPage,
  },
  {
    path: '/locations/maps-links',
    name: 'MapsLinks',
    component: MapsLinks,
  },
  {
    path: '/locations/limited-set-map',
    name: 'LimitedSetMap',
    component: LimitedSetMap,
  },
  {
    path: '/locations/limited-set-route-map',
    name: 'LimitedSetWithRouteMap',
    component: LimitedSetWithRouteMap,
  },
  {
    path: '/locations/inventory-map',
    name: 'InventoryMap',
    component: InventoryMap,
  },
  {
    path: '/locations/locked-map',
    name: 'LockedMap',
    component: LockedMap,
  },
  {
    path: '/locations/zone-map',
    name: 'ZoneMap',
    component: ZoneMap,
  },
  {
    path: '/skus',
    name: 'SkuManagement',
    component: SkusPage,
  },
  {
    path: '/create-sku',
    name: 'SkuCreate',
    component: SkuCreate,
  },
  {
    path: '/skus/:skuId',
    name: 'SkuDetails',
    component: SkuDetailsContainer,
    children: [
      {
        path: '',
        name: 'SkuEdit',
        component: SkuEdit,
      },
      {
        path: 'programs',
        name: 'SkuPrograms',
        component: SkuPrograms,
      },
      {
        path: 'components',
        name: 'SkuComponents',
        component: SkuComponents,
      },
      {
        path: 'parents',
        name: 'SkuParents',
        component: SkuParents,
      },
      {
        path: 'estimators',
        name: 'SkuEstimators',
        component: SkuEstimators,
      },
      {
        path: 'freight-packages',
        name: 'SkuFreightPackages',
        component: SkuFreightPackages,
      },
    ]
  },
  {
    path: '/sku-equivalents/:skuEquivalentId',
    name: 'SkuEquivalentDetails',
    component: SkuEquivalentDetail,
    props: true,
  },
  {
    path: '/programs',
    name: 'Program Management',
    component: ProgramsPage,
  },
  {
    path: '/create-program',
    name: 'ProgramCreate',
    component: ProgramCreate,
  },
  {
    path: '/programs/:programId',
    name: 'ProgramDetailsContainer',
    component: ProgramDetailsContainer,
    props: true,
    children: [
      {
        path: '',
        name: 'ProgramDashboard',
        component: ProgramDashboard,
      },
      {
        path: 'edit',
        name: 'ProgramEdit',
        component: ProgramEdit,
      },
      {
        path: 'locations',
        name: 'ProgramLocations',
        component: ProgramLocations,
      },
      {
        path: 'plans',
        name: 'ProgramPlans',
        component: ProgramPlans,
      },
      {
        path: 'skus',
        name: 'ProgramSkus',
        component: ProgramSkus,
      }
    ]
  },
  {
    path: '/create-plan',
    name: 'PlanCreate',
    component: PlanCreate,
  },
  {
    path: '/plans',
    name: 'PlanManagement',
    component: PlansPage,
  },
  {
    path: '/plans/:planId',
    name: 'PlanDetails',
    component: PlanDetail,
    props: true,
  },
  {
    path: '/recoveries-by-zone',
    name: 'RecoveriesByZone',
    component: RecoveriesByZone,
    props: true,
  },
  {
    path: '/recoveries-by-location',
    name: 'RecoveriesByLocation',
    component: RecoveriesByLocation,
    props: true,
  },
  {
    path: '/recoveries-by-location-by-program',
    name: 'RecoveriesByLocationByProgram',
    component: RecoveriesByLocationByProgram,
    props: true,
  },
  {
    path: '/recoveries-by-component',
    name: 'RecoveriesByComponent',
    component: RecoveriesByComponent,
  },

  /************** Reports ****************/
  {
    path: '/reports',
    name: 'Reports',
    component: ReportsPage,
    props: true,
  },
  {
    path: '/reports/orders',
    name: 'OrderItemsReport',
    component: OrderItemsReportPage,
    props: true,
  },
  {
    path: '/reports/late-notifications',
    name: 'lateNotificationsReport',
    component: LateNotificationsReportPage,
    props: true,
  },
  {
    path: '/reports/prebilling',
    name: 'PreBillingReport',
    component: PreBillingReportPage,
    props: true,
  },
  {
    path: '/reports/completed-orders',
    name: 'CompletedOrdersReport',
    component: CompletedOrdersReportPage,
    props: true,
  },
  {
    path: '/reports/invoicing',
    name: 'InvoicingReport',
    component: InvoicingReportPage,
    props: true,
  },
  {
    path: '/reports/inventory-movements',
    name: 'InventoryMovements',
    component: InventoryMovements,
  },
  {
    path: '/reports/inventory-ledger-99s',
    name: 'InventoryLedger99Page',
    component: InventoryLedger99Page,
  },
  {
    path: '/reports/inventory-by-component',
    name: 'InventoryByStage',
    component: InventoryByStage,
  },
  {
    path: '/reports/current-inventory-by-location',
    name: 'CurrentInventoryByLocation',
    component: CurrentInventoryByLocation,
  },
  {
    path: '/reports/historical-inventory-by-location',
    name: 'HistoricalInventoryByLocation',
    component: HistoricalInventoryByLocation,
  },
  {
    path: '/reports/cycle-count',
    name: 'CycleCountReport',
    component: CycleCountReportPage,
  },
  {
    path: '/reports/:reportId',
    name: 'ReportDetail',
    component: ReportDetail,
    props: true,
  },
  {
    path: '/report-job-details/:reportId',
    name: 'ReportJobDetails',
    component: ReportJobDetailList,
    props: true,
  },

  /************** Help/Info ****************/
  {
    path: '/help-files',
    name: 'HelpFiles',
    component: HelpFiles,
  },

  /************** Admin ****************/
  {
    path: '/admin/users',
    name: 'Users',
    component: UsersList,
  },
  {
    path: '/admin/create-user',
    name: 'UserCreate',
    component: UserCreate,
  },
  {
    path: '/admin/users/:userId',
    name: 'UserDetails',
    component: UserDetail,
    props: true,
  },
  {
    path: '/admin/master-adjustment',
    name: 'MasterAdjustment',
    component: MasterAdjustment,
  },
  {
    path: '/admin/call-priority-types',
    name: 'CallPriorityTypes',
    component: CallPriorityTypeList,
  },
  {
    path: '/admin/week-numbers',
    name: 'WeekNumbers',
    component: WeekNumberConfigList,
  },
  {
    path: '/admin/zones',
    name: 'Zones',
    component: ZonesList,
    props: true,
  },
  {
    path: '/admin/zones/new',
    name: 'ZonesCreate',
    component: ZonesCreate,
    props: true,
  },
  {
    path: '/admin/zones/:zoneCode',
    name: 'ZonesEdit',
    component: ZonesEdit,
    props: true,
  },
  {
    path: '/admin/imports',
    name: 'Imports',
    component: ImportUploads
  },
  {
    path: '/admin/imports-list',
    name: 'ImportFilesList',
    component: ImportFilesList
  },
  {
    path: '/admin/imports-errors/:fileId',
    name: 'ImportFileErrors',
    component: ImportFileErrors,
    props: true,
  },
  {
    path: '/admin/tools',
    name: 'Tools',
    component: DeveloperTools,
    props: true,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  switch (to.name) {
    case 'LoginPage':
    case 'LandingPage':
    case 'DashboardCallers':
    case 'AdminDashboard':
    case 'UserDashboard':
    case 'AccessDeniedPage':
    case 'MaintenanceModeEnabledPage':
    case 'NotFoundPage':
    case 'DashboardAccountsCustomer':
    case 'AccountOverview1':
    case 'AccountOverview2':
    case 'HelpFiles':
      // Any route names above will bypass an authorization check
      next(true)
      break
    default:
      const authorizationService = new AuthorizationService()
      authorizationService.route({ params: {
          route_name: to.name,
          route_params: to.params,
        }})
        .then((response) => {
          if (response.data.maintenanceModeEnabled === true) {
            next({ name: 'MaintenanceModeEnabledPage' })
          } else if (response.data.notFound === true) {
            next({
              name: 'NotFoundPage',
              params: {
                pathMatch: to.path.substring(1).split('/'),
                message: response.data.message
              },
              query: to.query,
              hash: to.hash,
            })
          } else if (response.data.authorized === false) {
            next({
              name: 'AccessDeniedPage',
              params: {
                pathMatch: to.path.substring(1).split('/'),
              },
              query: to.query,
              hash: to.hash,
            })
          } else {
            next(true)
          }
        })
        .catch((err) => {
          console.log(err)
          next(false)
        })
      break
  }
})

export default router
